import React, { useEffect, useState } from 'react';
import { parseDataCalculator, parseDataCurrencies } from 'helpers';
import { Calculator } from '..';
import { Container } from './style';
import { Fragment } from 'react';

export const Currency = ({
  data,
  usdBlueTourist,
  title,
  className,
  sponsor = false,
}) => {
  const { primary } = parseDataCurrencies(data, usdBlueTourist);
  const [formattedUpdates, setFormattedUpdates] = useState({});

  useEffect(() => {
    primary.forEach((element) => {
      if (element && element.update && !formattedUpdates[element.name]) {
        const formattedDate = (element.update);
        setFormattedUpdates((prevUpdates) => ({
          ...prevUpdates,
          [element.name]: formattedDate,
        }));
      }
    });
  }, [primary, formattedUpdates]);

  const currencyName = (name) => {
    switch (name) {
      case "Dólar Turista":
        name = "*";
        break;

        case "Dólar MEP":
        name = "*";
        break;

        case "Dólar CCL":
        name = "*";
        break;
    
      default:
        name = "";
        break;
    }
    return name;
  }
  
  return (
    <Container>
      <div className={`title-container ${className}`}>
        <p className={`title ${className}`}>{title}</p>
        <div className="api-provided">
          
          <div className="provided">
            <span>INFORMACIÓN DE</span>
            <a href="https://www.byma.com.ar/" target="_blank">
              <img
                width="81px"
                height="30px"
                src="/img/currency/small_byma.png"
                alt="BYMA"
              />
            </a>
          </div>
          <div className="provided">
            <span>PROVISTO POR</span>
            <a href="https://www.invertironline.com/" target="_blank">
              <img
                width="122"
                height="30"
                src="/img/currency/icon-invertir_small.png"
                alt="Invertir Online"
              />
            </a>
            <span>con 20 minutos de diferido*</span>
          </div>
          
        </div>
      </div>
      <div className="dolar-grid">
        {primary.map((element, index) => (
          <Fragment key={`currencyP${index}`}>
            {element && (
              <div className="card">
                <div className="card-content">
                  <h2>{element.name}</h2>
                  <div className="currency-values">
                    <div className="buying">
                      <p>COMPRA</p>
                      {element.buyingRate && (
                        <span>{`$${element.buyingRate}`}</span>
                      )}
                    </div>
                    <div className="separator"></div>
                    <div className="selling">
                      <p>VENTA</p>
                      {element.sellingRate && (
                        <span>{`$${element.sellingRate}`}</span>
                      )}
                    </div>
                  </div>
                  {!formattedUpdates[element.name] ? (
                    <span className="last-value">Último valor obtenido</span>
                  ) : (
                    <span className="last-value">{currencyName(element.name)}{`Último valor obtenido al ${formattedUpdates[element.name]}`}</span>
                  )}
                  <a
                    className="button"
                    href={`/economia/divisas-acciones-bonos/monedas/${element.url}`}
                  >
                    Ver
                  </a>
                </div>
              </div>
            )}
          </Fragment>
        ))}

        <Calculator currencies={parseDataCalculator(data, usdBlueTourist)} />
      </div>
    </Container>
  );
};

export default Currency;
